import { useTranslation } from "react-i18next";
import { HeaderLeft } from "../../../components/Layout/Layout";
import {
  ContentWrapper,
  FullWidthHorizontalSeparator,
  PageHeader,
  PageTitle,
  PageWrapper,
} from "../../../layout/portalPageLayout";
import { useHistory } from "react-router-dom";
import { useRoutePath } from "../../../util/Routing";
import { useCallback, useEffect, useState } from "react";
import { NumberParam, StringParam, useQueryParams } from "use-query-params";
import { CustomTabPanel } from "../../../components/ReachTabs/TabPanel";
import { CreateNewTenantFormContainer } from "../../../components/CreateNewTenantForm/CreateNewTenantFormContainer";
import { useAuthenticatedUser } from "../../../hooks/useAuthenticatedUser";
import { TabPanels, Tabs } from "@reach/tabs";
import { Tab } from "../../../components/ReachTabs/Tab";
import styled from "styled-components/macro";
import { TabList } from "../../../components/ReachTabs/TabList";
import { BulkUploadCustomers } from "../../admin/SellerAdmin/BulkUploadCustomers/BulkUploadCustomers";
import { spacingTokens } from "../../../designTokens";

const StickyTabList = styled(TabList)`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.primaryBG};
`;

type CreateTenantPageProps = {
  customer_type: "buyer" | "distributor";
};

export const CreateTenantPage = ({
  customer_type,
}: CreateTenantPageProps): JSX.Element => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [query, setQuery] = useQueryParams({
    tab: NumberParam,
    uploadNumber: StringParam,
  });

  const { t } = useTranslation();
  const history = useHistory();
  const user = useAuthenticatedUser();
  const { adminPath } = useRoutePath();

  const changeTab = useCallback(
    (index: number) => {
      setCurrentTab(index);
      setQuery({ tab: index });
    },
    [setQuery]
  );

  useEffect(() => {
    changeTab(query.tab ?? 0);
  }, [changeTab, query.tab]);

  const isDistributor = customer_type === "distributor";
  const tenantType = isDistributor ? "Distributor" : "Buyer";
  const newTenantLabel = isDistributor
    ? t("New Distributor")
    : t("New Customer");
  const pageTitle = isDistributor
    ? t("Create Distributor")
    : t("Create Customer");
  const listPath = isDistributor ? "distributors" : "tenants";
  const bulkUploadCustomerType = isDistributor ? "distributors" : "customers";

  const TabsList = [
    <Tab key="new_tenant">{newTenantLabel}</Tab>,
    <Tab key="bulk_upload">{t("Bulk Upload")}</Tab>,
  ];
  const TabPanelList: JSX.Element[] = [
    <CustomTabPanel key="new_tenant" refreshKey={currentTab}>
      <div style={{ margin: spacingTokens.spacing_5xl, maxWidth: "512px" }}>
        <CreateNewTenantFormContainer
          sellerTenantId={user.tenant_id}
          type={tenantType}
          onSuccess={(tenantID) => {
            history.push(`${adminPath}/${listPath}/${tenantID}`);
          }}
          onCancel={() => history.push(`${adminPath}/${listPath}`)}
          showTitle={false}
        />
      </div>
    </CustomTabPanel>,
    <CustomTabPanel key="bulk_upload" refreshKey={currentTab}>
      <div style={{ margin: spacingTokens.spacing_5xl }}>
        <BulkUploadCustomers customer_type={bulkUploadCustomerType} />
      </div>
    </CustomTabPanel>,
  ];
  return (
    <PageWrapper style={{ padding: spacingTokens.spacing_xl }}>
      <PageHeader style={{ marginBottom: spacingTokens.spacing_md }}>
        <HeaderLeft>
          <PageTitle>{pageTitle}</PageTitle>
        </HeaderLeft>
      </PageHeader>
      <ContentWrapper>
        <Tabs onChange={changeTab} index={currentTab}>
          <StickyTabList>{TabsList}</StickyTabList>
          <FullWidthHorizontalSeparator />
          <TabPanels>{TabPanelList}</TabPanels>
        </Tabs>
      </ContentWrapper>
    </PageWrapper>
  );
};
